import { features } from '@/mocks/homeData';

export default function FeaturesSection() {
  return (
    <section id="features" className="w-full py-16 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-12">
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">
              平台优势
            </h2>
            <p className="text-sm text-foreground-500 max-w-lg mx-auto">
              为什么选择草民影院？五大核心优势为你护航
            </p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4 md:gap-6">
            {features.map((item, idx) => (
              <div
                key={idx}
                className="bg-background-100 rounded-xl p-5 md:p-6 text-center border border-background-200/60 transition-all duration-300 hover:-translate-y-1"
              >
                <div className="w-14 h-14 mx-auto mb-4 flex items-center justify-center bg-primary-100 rounded-2xl">
                  <i className={`${item.icon} text-2xl text-primary-600`}></i>
                </div>
                <h3 className="text-base font-heading font-semibold text-foreground-900 mb-2">
                  {item.title}
                </h3>
                <p className="text-xs text-foreground-500 leading-relaxed">{item.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}